/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Videos_Delete_ConfirmInputs */

const cs_projects_videos_delete_confirm = /** @type {(inputs: Projects_Videos_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat toto video projektu?`)
};

const en_projects_videos_delete_confirm = /** @type {(inputs: Projects_Videos_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this project video?`)
};

/**
* | output |
* | --- |
* | "Delete this project video?" |
*
* @param {Projects_Videos_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_videos_delete_confirm = /** @type {((inputs?: Projects_Videos_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Videos_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_videos_delete_confirm(inputs)
	return cs_projects_videos_delete_confirm(inputs)
});